export default {
  setInhabitantChange: (state, inhabitantChange) => {
    state.inhabitantChange = inhabitantChange;
  }
};
